export const API_BASE = '/api';

// Keep endpoint paths relative; axios baseURL applies the /api prefix once.
export const ENDPOINTS = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    me: '/auth/me',
    forgot: '/auth/password/forgot',
    reset: '/auth/password/reset',
    changeEmail: '/auth/email/change',
    changePassword: '/auth/password/change',
    activate: '/auth/activate',
    exportData: '/auth/export-data',
    deleteAccount: '/auth/delete-account',
    validateNip: '/auth/nip/validate',
  },
  admin: {
    cronJobs: '/admin/cron/jobs',
    cronJob: (key) => `/admin/cron/jobs/${encodeURIComponent(key)}`,
    runCronJob: (key) => `/admin/cron/jobs/${encodeURIComponent(key)}/run`,
    userList: '/admin/users',
    createAdmin: '/admin/users/admins',
    updateUser: (id) => `/admin/users/${encodeURIComponent(id)}`,
    deleteUser: (id) => `/admin/users/${encodeURIComponent(id)}`,
    notifyUser: (id) => `/admin/users/${encodeURIComponent(id)}/notify`,
    messageUser: (id) => `/admin/users/${encodeURIComponent(id)}/message`,
    reports: '/admin/reports',
    report: (id) => `/admin/reports/${encodeURIComponent(id)}`,
    reportMessage: (id) => `/admin/reports/${encodeURIComponent(id)}/message`,
    reportBlock: (id) => `/admin/reports/${encodeURIComponent(id)}/block`,
  },
  contact: '/contact',
  homegrid: '/homegrid',
  homegridTop: '/homegrid/top',
  homegridInfluencer: (id) => `/homegrid/influencer/${encodeURIComponent(id)}`,
  homegridComments: (elementId) => `/homegrid/elements/${encodeURIComponent(elementId)}/comments`,
  homegridCommentDelete: (commentId) => `/homegrid/elements/comments/${encodeURIComponent(commentId)}`,
  followInvites: '/follow-invites',
  company: {
    favorites: '/company/favorites',
    follow: '/company/follow',
    following: '/company/following',
    influencers: '/company/influencers',
    profileLikes: '/company/profile-likes',
    profile: '/company/profile',
  },
  guest: {
    favorites: '/guest/favorites',
    follow: '/guest/follow',
    following: '/guest/following',
    profileLikes: '/guest/profile-likes',
    profile: '/guest/profile',
  },
  influencer: {
    favorites: '/influencer/favorites',
    follow: '/influencer/follow',
    following: '/influencer/following',
    followers: '/influencer/followers',
    followersSearch: '/influencer/followers/search',
    followersInvite: '/influencer/followers/invite',
    profileLikes: '/influencer/profile-likes',
    profile: '/influencer/profile',
    grid: '/influencer/grid',
    gridItem: (id) => `/influencer/grid/${encodeURIComponent(id)}`,
    portfolio: '/influencer/portfolio',
    portfolioItems: '/influencer/portfolio/items',
    portfolioItem: (id) => `/influencer/portfolio/items/${encodeURIComponent(id)}`,
  },
  publicPortfolio: (id) => `/portfolio/${encodeURIComponent(id)}`,
  publicPortfolioPdf: (id) => `/portfolio/${encodeURIComponent(id)}/pdf`,
  notifications: {
    list: '/notifications',
    markRead: '/notifications/mark-read',
    markAll: '/notifications/mark-all',
    settings: '/notifications/settings',
    adminBroadcast: '/notifications/admin/broadcast',
  },
  subscription: {
    current: '/payments/subscription',
    payments: '/payments/subscription/payments',
    checkout: '/payments/subscription/checkout',
    sessionStatus: '/payments/subscription/session-status',
  },
  upload: {
    avatar: '/upload/avatar',
    deleteAvatar: '/upload/avatar',
    photo: '/upload/photo',
    portfolioPhoto: '/upload/portfolio-photo',
  },
  messages: {
    threads: '/messages/threads',
    threadMessages: (id) => `/messages/threads/${encodeURIComponent(id)}/messages`,
    createThread: '/messages/threads',
    markRead: (id) => `/messages/threads/${encodeURIComponent(id)}/read`,
    uploadAttachment: '/upload/message-attachment',
    admins: '/messages/admins',
  },
  reports: {
    create: '/reports',
  },
};
